<!-- src/App.svelte — v8
     等 ContentDataStore 載入完成後才 render,沿用原日本專題的模式
     ({#if $ContentDataStore}) -->
<script>
  import Header from './components/Header.svelte'
  import Footer from './components/Footer.svelte'
  import MobileDetector from './utils/MobileDetector.svelte'
  import AuthorInfo from './components/AuthorInfo.svelte'
  import SocialBoxArticle from './components/SocialBoxArticle.svelte'
  import ArticleList from './components/ArticleList.svelte'

  import ContentDataStore from './stores/ContentDataStore.js'

  // 海峽專題的元件
  import OverviewMap from './components/OverviewMap.svelte'
  import Cover from './components/Cover.svelte'
  import BasicParagraphs from './shared/BasicParagraphs.svelte'
  import StraitJumpNav from './components/StraitJumpNav.svelte'
  import StraitTabs from './components/StraitTabs.svelte'
  import StraitMap from './components/StraitMap.svelte'
  import StraitMapStepScroller from './components/StraitMapStepScroller.svelte'
</script>

<style>
  /* === v11 路透淺色配色系統 (全域 CSS 變數) === */
  :global(:root) {
    /* 背景 */
    --color-bg: #f3f1ec;          /* 米白暖灰 */
    --color-bg-paper: #ffffff;     /* 白遮罩 / 蓋板 */
    --color-bg-elevated: #fafaf7;  /* 略升起的卡片 */

    /* 文字 */
    --color-text: #222222;         /* 深炭主文字 */
    --color-text-dim: #777777;     /* 次要文字 / 國家名 */
    --color-text-muted: #9aa5b0;   /* 海灣標注(偏藍灰) */

    /* 強調色(路透磚紅 + 深藍 / 沉穩綠 + 赭石黃) */
    --color-accent: #d44545;       /* 路透磚紅 — 警示 / 重點 */
    --color-blue: #3e6a8a;         /* 深藍 — 港口、阿聯酋管線 */
    --color-green: #5a8a6a;        /* 沉穩綠 — 沙烏地管線 */
    --color-amber: #c8995a;        /* 赭石 — 軌跡、輔助 */

    /* 地圖底色 */
    --color-sea: #ffffff;          /* 海洋(SVG 底,純白對比陸地) */
    --color-land: #dcd7cd;         /* 陸地暖灰米 */
    --color-border: #ffffff;       /* 國界(白色細線) */

    /* 過渡幕(深炭) */
    --color-curtain: #222222;      /* 深炭幕 — 海峽過渡 */
    --color-curtain-text: #ffffff; /* 深炭幕上的文字 */
  }

  :global(html) {
    background: var(--color-bg);
  }
  :global(body) {
    background: var(--color-bg);
    color: var(--color-text);
    font-family: 'Noto Sans TC', 'Source Sans Pro', -apple-system, BlinkMacSystemFont, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  article { margin: 0 auto; width: 100%; }
  section { margin: 0 auto; width: 100%; }
  .map-stage-container { position: relative; width: 100%; }
</style>

<MobileDetector />

{#if $ContentDataStore}
  <!-- 懸浮快速切換列(只在地圖 sticky 時顯示) -->
  <StraitTabs />

  <Header />

  <main>
    <article>
      <!-- 1. 全景地圖 -->
      <section>
        <OverviewMap />
      </section>

      <!-- 2. 封面標題 -->
      <section>
        <Cover />
      </section>

      <!-- 3. 前言(走 BasicParagraphs,從 JSON 的 prologue 陣列讀) -->
      <section>
        <BasicParagraphs sectionName="prologue" />
      </section>

      <!-- 4. 跳轉按鈕 -->
      <section>
        <StraitJumpNav />
      </section>

      <!-- 5. 局部海峽 scrollytelling -->
      <section class="map-stage-container">
        <StraitMapStepScroller sceneName="strait-map">
          <StraitMap />
        </StraitMapStepScroller>
      </section>

      <!-- 6. 結語(選填,走 BasicParagraphs,從 JSON 的 epilogue 陣列讀) -->
      <section>
        <BasicParagraphs sectionName="epilogue" />
      </section>

      <!-- 7. 作者資訊 -->
      <section>
        <AuthorInfo />
      </section>
    </article>

    <!-- 8. 社交分享 -->
    <SocialBoxArticle shareUrl={$ContentDataStore.article_url} />

    <!-- 9. 延伸閱讀 -->
    <ArticleList projectName={$ContentDataStore.project_name}
                 articleData={$ContentDataStore.read_more_articles} />
  </main>
{/if}

<Footer />
